<template>
  <div :class="classes">
    <pt-page-title title="意见反馈详情"></pt-page-title>
    <pt-sub-title title="意见反馈详情"></pt-sub-title>
    <template>
      <div :class="$style['pt-pt-feedback-detail']">
        <table>
          <tr>
            <td>姓名：</td>
            <td>{{detail.name}}</td>
          </tr>
          <tr>
            <td>手机：</td>
            <td>{{detail.mobile}}</td>
          </tr>
          <tr>
            <td>邮箱：</td>
            <td>{{detail.email}}</td>
          </tr>
          <tr>
            <td>提交时间：</td>
            <td>{{detail.createdDate}}</td>
          </tr>
          <tr>
            <td>内容：</td>
            <td>{{detail.content}}</td>
          </tr>
          <tr>
            <td>截图：</td>
            <td>
              <div></div>
              <wt-box class="doc-wt-box" direction="row">
                <div></div>
                <div class="wt-box__item" v-for="(item,index) in detail.imageUrl" :key="index">
                  <img :src="$privateResourcesUrl + item" :class="$style.images" @click="onPreview(index)">
                </div>
              </wt-box>
            </td>
          </tr>

        </table>

      </div>
    </template>
    <wt-image-preview v-if="previewVisible" @close-preview="closePreview" :value="images" :initial-index="currentIndex" :loop="false"></wt-image-preview>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-pt-feedback-detail'

export default {
  name: 'pt-pt-feedback-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      detail: {},
      previewVisible: false,
      currentIndex: 1,
      privateResourcesUrl: this.$privateResourcesUrl,
      images: ''
    }
  },
  methods: {
    onPreview (index) {
      this.images = []
      this.currentIndex = index
      this.detail.imageUrl.forEach(item => {
        this.images.push(this.privateResourcesUrl + item)
      })
      this.previewVisible = true
    },
    closePreview () {
      this.previewVisible = false
    },
    getDetail () {
      this.$store.dispatch('getFeedbackDetail', this.$route.params.id).then(ret => {
        this.detail = ret.data
      }).catch(err => {
        this.$message.error(err || '获取意见反馈详情失败')
      })
    }
  },
  created () {
    this.getDetail()
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  @import "~less/var.less";

  :global {
    .pt-pt-feedback-detail {
      .el-checkbox+.el-checkbox {
        margin-left: 0
      }
      .wt-box{
        justify-content: flex-start;
        margin-left: -1rem
      }
      .wt-box__item{
        margin-right: .5rem
      }
    }

  }

  .pt-pt-feedback-detail {

    padding: 50px 20px;
    display: flex;
    flex-direction: row;

    :global table {
      tr {
        td {
          line-height: 40px;
          font-size: 16px;
        }

        :first-child {
          width: 1rem;
          display: -webkit-box;
          color: @mainColor;
          justify-content: flex-end;
        }
      }
    }
    .el-checkbox+.el-checkbox {
      margin: 0
    }
  }

  .title {
    max-width: 300PX;
  }

  .images{
  // display: inline;
  width: 2rem !important;
  }

</style>
